import React, { FunctionComponent, ReactElement } from 'react';
import { ClockIcon } from '../icons';
import Typography from '../typography/Typography';
import './timeStamp.scss';

type TimeStampProps = {
  timeInSeconds: number,
  icon?: ReactElement,
  className?: string,
  showSeconds?: boolean
}

const TimeStamp: FunctionComponent<TimeStampProps> = ({
  timeInSeconds,
  icon,
  className = '',
  showSeconds = false,
}) => {
  function secondsToHm(seconds: number) {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60);
    const s = Math.floor((seconds % 3600) % 60);

    const hDisplay = h > 0 ? `${h}h` : '';
    const mDisplay = m > 0 ? `${m}m` : '';
    const sDisplay = s > 0 ? `${s}s` : '';

    return `${hDisplay} ${mDisplay}${showSeconds ? ` ${sDisplay}` : ''}`;
  }

  return (
    <div className={`time-stamp d-flex align-items-center ${className}`}>
      {icon || (
        <ClockIcon
          color="light"
          className="m-r-8"
          direction="right"
        />
      )}
      <Typography
        variant="button"
        color="light"
      >
        {secondsToHm(timeInSeconds)}
      </Typography>
    </div>
  );
};

export default TimeStamp;
